import constants from '@/commons/constants';
import moment from 'moment';
const filters = {
    /**
     * 常量过滤器，接受常量代码
     * @param classCode
     * @param input
     * @returns {*}
     */
    constantsFilter(input, classCode, string) {
        if (!input && input !== 0 && input !== '0') {
            return string || '';
        }
        if (classCode !== undefined && input !== undefined) {
            return constants[classCode][input];
        } else {
            return string || '';
        }
    },

    /**
     * 格式化时间
     * @param {*} value
     * @param {*} type
     */
    formateDateFilter(value, type = 'YYYY-MM-DD') {
        if (!value) {
            return '';
        }
        return moment(value).format(type);
    },

    /**
     * 隐藏手机号
     * @param {*} value
     */
    telFormateFilter(value) {
        if (value) {
            return value.substr(0, 3) + '****' + value.substr(7, 11);
        } else {
            return '--';
        }
    },

    /**
     * 空值处理
     * @param {*} value
     */
    noDataFilter(value) {
        switch (value) {
            case undefined:
                return '--';
            case null:
                return '--';
            case '':
                return '--';
            default:
                return value;
        }
    },

    /**
     * 格式化百分比
     * @param val
     * @param isDecimal （是否为小数）
     * @returns {string}
     * @param {*} value
     */
    percentageFilter(val, isDecimal = false) {
        if (val !== null && val !== undefined && val !== '') {
            let rate = val - 0;
            if (isDecimal) {
                rate = (val * 100).toFixed(2) - 0;
            }
            if (rate === 0) {
                return rate + '';
            } else {
                return rate + '%';
            }
        } else {
            return '--';
        }
    },
    /**
     * 格式化金额
     * @param {*} str
     * @param {*} digit
     */
    amountFilter(str, digit = 2) {
        let minus = '';
        if (str) {
            if (!/\d+(\.\d+)?/.test(str + '')) return str;
            let num = parseFloat(str).toFixed(digit);
            let sNum = /^\d+/g.exec(Math.abs(num))[0];
            let length = sNum.length;
            let y = Math.floor(length / 3);
            sNum = sNum.split('').reverse();
            for (let i = 1; i <= y; i++) {
                if (i === y && length / 3 === y) break;
                sNum.splice(3 * i + i - 1, 0, ',');
            }
            if (num < 0) minus = '-';
            return minus + sNum.reverse().join('') + /\.\d+$/.exec(num)[0];
        } else {
            str = 0;
            return str.toFixed(digit);
        }
    },

    /**
     * 小数取整
     * @param {*} val
     * @param {保留几位小数} precision
     * @param {单位} unit
     */
    toFixedFilter(val, precision = 2, unit = '') {
        if (val !== null && val !== undefined && val !== '') {
            val = val - 0;
            val = val.toFixed(precision) - 0;
            if (val === 0) {
                return 0;
            } else {
                return val.toFixed(precision) + unit;
            }
        } else {
            return '--';
        }
    },

    /**
     * 货币取元
     * @param {*} val
     * @param {千分隔符} thousandSplit
     * @param {缩放比例} scale
     * @param {小数位} digit
     */
    singleToTenFilter(
        val,
        thousandSplit = false,
        scale = 100,
        digit = 2,
        placeholder = '--'
    ) {
        if (val === null || val === '' || val === undefined) {
            return placeholder;
        } else {
            val = (val / scale).toFixed(digit) - 0;
        }
        if (val === 0) {
            return 0;
        } else {
            if (thousandSplit) {
                return val
                    .toString()
                    .replace(/(^|\s)\d+/g, m =>
                        m.replace(
                            new RegExp('(\\d)(?=(\\d{3})+$)', 'ig'),
                            '$1,'
                        )
                    );
            } else {
                return val;
            }
        }
    },

    /**
     * 千分隔符
     */
    singleToThousandSplitFilter(val) {
        if (val === null || val === undefined || val === '') {
            return '--';
        } else {
            val = parseInt(val / 100) + '';
            return val.replace(new RegExp('(\\d)(?=(\\d{3})+$)', 'ig'), '$1,');
        }
    }
};

const install = function(Vue) {
    for (let key of Object.keys(filters)) {
        Vue.filter(key, filters[key]);
    }
};

export default install;
